import { BrowserRouter, Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { useState } from "react";

import Sidebar from "./components/layout/Sidebar";
import Topbar from "./components/layout/Topbar";

import Dashboard from "./pages/Dashboard";
import Settings from "./pages/Settings";
import UserManagement from "./pages/UserManagement";
import Login from "./pages/Login";

import "./App.css";

/* =====================
   AUTH GUARD
===================== */
const ProtectedRoute = ({ token, children }) => {
  return token ? children : <Navigate to="/login" replace />;
};

/* =====================
   APP LAYOUT
===================== */
function AppLayout({ token, setToken }) {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const navigate = useNavigate();

  /* =====================
     LOGOUT HANDLER
  ===================== */
  const handleLogout = () => {
    localStorage.clear(); // clears token, loginID, role
    setToken(null);
    navigate("/login", { replace: true });
  };

  return (
    <div className="app-container">
      {token && (
        <Sidebar
          isOpen={sidebarOpen}
          onLogout={handleLogout}
        />
      )}

      <div className="main-content">
        {token && (
          <Topbar
            toggleSidebar={() => setSidebarOpen(!sidebarOpen)}
            onLogout={handleLogout}
          />
        )}

        <main className="content-wrapper">
          <Routes>
            {/* Public */}
            <Route path="/login" element={<Login onLogin={setToken} />} />

            {/* Protected */}
            <Route
              path="/"
              element={
                <ProtectedRoute token={token}>
                  <Dashboard />
                </ProtectedRoute>
              }
            />

            <Route
              path="/user-management"
              element={
                <ProtectedRoute token={token}>
                  <UserManagement />
                </ProtectedRoute>
              }
            />

            <Route
              path="/settings"
              element={
                <ProtectedRoute token={token}>
                  <Settings />
                </ProtectedRoute>
              }
            />

            {/* Catch-all */}
            <Route
              path="*"
              element={<Navigate to={token ? "/" : "/login"} replace />}
            />
          </Routes>
        </main>
      </div>
    </div>
  );
}

/* =====================
   ROOT APP
===================== */
export default function App() {
  const [token, setToken] = useState(localStorage.getItem("token"));
  
  return (
    <BrowserRouter>
      <AppLayout token={token} setToken={setToken} />
    </BrowserRouter>
  );
}
